(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxInTreeCreate(
    toastr, $filter
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/sites/inTreeCreate/inTreeCreate.template.html',
      link: function(scope, element) {

        (function() {
          init();
        })();

        function init () {
          scope.name = '';
          scope.invalidName = true;

          element.on("keydown keypress", function (event) {
            if(event.which === 13) {
              event.preventDefault();
              scope.$apply(function (){
                if (!scope.invalidName) {
                  scope.createSiteInTree();
                }
              });
            }
          });
        }

        scope.$watch(function() {
          return scope.context
        }, function(oldVal, newVal) {
          if (oldVal !== newVal) {
            init();
          }
        })

        scope.validateName = function () {
          if (scope.name.length > 0) {
            scope.invalidName = false;
          } else {
            scope.invalidName = true;
          }
        }

        scope.createSiteInTree = function () {
          scope.context.createSiteInTree(scope.name, scope.meta.type).then(function(response) {
            toastr.success($filter("translate")("ChangesSaved"));
          }).catch(function(error){});
          scope.callback();
        }

        scope.$on('$destroy', function() {
          element.off("keydown keypress");
        });



      }
    };
  }

  pxInTreeCreate.$inject = ['toastr', '$filter'];

  angular
    .module('printix-admin')
    .directive('pxInTreeCreate', pxInTreeCreate);

})();
